if (!customElements.get('emergent-cpap-details')) {
  customElements.define(
    'emergent-cpap-details',
    class EmergentCpapDetails extends HTMLElement {
      connectedCallback() {
        this.onVariantInputChange = this.onVariantInputChange.bind(this);
        this.shippingRow = this.querySelector('[data-shipping-row]');
        this.shippingValue = this.querySelector('[data-shipping-value]');
        try {
          this.weights = JSON.parse(this.querySelector('[data-shipping-weights]').textContent);
        } catch {
          return;
        }
        document.addEventListener('change', this.onVariantInputChange);
        const mainProduct = document.querySelector(`product-info[id^="MainProduct-"][data-product-id="${this.dataset.productId}"]`);
        const input = mainProduct?.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
        if (input) this.updateWeight(input.value);
      }

      disconnectedCallback() {
        document.removeEventListener('change', this.onVariantInputChange);
      }

      onVariantInputChange(event) {
        const input = event.target;
        if (!input.matches?.('form[data-type="add-to-cart-form"] input[name="id"]')) return;
        const mainProduct = input.closest('product-info[id^="MainProduct-"]');
        if (mainProduct?.dataset.productId !== this.dataset.productId) return;
        this.updateWeight(input.value);
      }

      updateWeight(variantId) {
        const weight = this.weights[String(variantId)] || '';
        if (this.shippingRow && this.shippingValue) {
          this.shippingRow.hidden = !weight;
          this.shippingValue.textContent = weight;
        }
        this.hidden = this.dataset.hasSpecifications !== 'true' && !weight;
      }
    }
  );
}
